export const TRADE_TAGS = [
  {
    value: "No third party",
    label: "No third party",
  },

] as const;

export const WALLECTCONNECT_ICON = "/images/logos/WalletConnectLogo.svg";